"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initHints = void 0;
const initHints = () => {
    document.querySelectorAll('.hint__wrapper').forEach(wrapper => {
        const trigger = wrapper.querySelector('.hint__trigger');
        if (!trigger)
            return;
        const mode = wrapper.dataset.hintMode || 'hover';
        const handleToggle = () => {
            const isActive = wrapper.classList.toggle('hint__wrapper--active');
            trigger.setAttribute('aria-expanded', isActive ? 'true' : 'false');
            if (isActive) {
                const closeOnOutsideClick = (event) => {
                    if (!wrapper.contains(event.target)) {
                        wrapper.classList.remove('hint__wrapper--active');
                        trigger.setAttribute('aria-expanded', 'false');
                        document.removeEventListener('click', closeOnOutsideClick);
                        document.removeEventListener('keydown', closeOnEscape);
                    }
                };
                const closeOnEscape = (event) => {
                    if (event.key === 'Escape') {
                        wrapper.classList.remove('hint__wrapper--active');
                        trigger.setAttribute('aria-expanded', 'false');
                        document.removeEventListener('click', closeOnOutsideClick);
                        document.removeEventListener('keydown', closeOnEscape);
                    }
                };
                setTimeout(() => {
                    document.addEventListener('click', closeOnOutsideClick);
                    document.addEventListener('keydown', closeOnEscape);
                }, 0);
            }
        };
        const handleKeydown = (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                handleToggle();
            }
        };
        if (mode === 'click') {
            trigger.addEventListener('click', handleToggle);
            trigger.addEventListener('keydown', handleKeydown);
        }
        else if (mode === 'hover' && !window.matchMedia('(any-hover: hover)').matches) {
            trigger.addEventListener('click', handleToggle);
            trigger.addEventListener('keydown', handleKeydown);
        }
    });
};
exports.initHints = initHints;
